import { Injectable } from '@angular/core';

// TODO(WARP-2295): Remove this service, the interceptor, and all v2signup gating once v2 is the default flow
@Injectable({ providedIn: 'root' })
export class V2SignupService {
  private _enabled = false;

  get enabled(): boolean {
    return this._enabled;
  }

  setEnabled(value: boolean): void {
    this._enabled = value;
  }
}
